var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.white)?_c('img',{staticStyle:{"width":"50px","height":"50px"},attrs:{"src":require("@/assets/images/epos_loading_white.gif")}}):_c('div',{staticClass:"loading-gif"})}
var staticRenderFns = []

export { render, staticRenderFns }